<template>
  <VExpansionPanel>
    <VExpansionPanelHeader class="font-weight-medium">
      {{ faq.question }}
    </VExpansionPanelHeader>
    <VExpansionPanelContent class="subtitle-2 font-weight-light">
      {{ faq.answer }}
      <div class="primary--text mt-4">
        <VBtn
          color="primary"
          text
          :loading="editLoading"
          @click="showEditDialog"
        >
          <span class="text-transform-none pseudo-link">{{ $t('edit') }}</span>
        </VBtn>
        <VBtn
          color="primary"
          text
          :loading="destroyLoading"
          @click="showDestroyDialog"
        >
          <span class="text-transform-none pseudo-link">{{ $t('delete') }}</span>
        </VBtn>
      </div>
      <VDialog v-model="editDialog" max-width="500">
        <VCard class="pa-5">
          <VTextField
            v-model="question"
            outlined
            dense
            type="text"
            autocomplete="off"
            :error-messages="errors.question"
          >
            <template v-slot:label>
              {{ $t('question') }} <span>*</span>
            </template>
          </VTextField>
          <VTextarea
            v-model="answer"
            outlined
            :error-messages="errors.answer"
          >
            <template v-slot:label>
              {{ $t('answer') }} <span>*</span>
            </template>
          </VTextarea>

          <div class="text-right">
            <VBtn
              color="success"
              outlined
              @click="closeEditDialog"
            >
              {{ $t('close') }}
            </VBtn>
            <VBtn
              color="success"
              :loading="editLoading"
              class="ml-2"
              elevation="0"
              @click="edit"
            >
              {{ $t('save') }}
            </VBtn>
          </div>
        </VCard>
      </VDialog>
      <VDialog v-model="destroyDialog" max-width="450">
        <VCard class="text-center pa-3">
          <div class="title mb-3">
            {{ $t('deleteWarning') }}
          </div>
          <VBtn
            color="success"
            text
            :loading="destroyLoading"
            @click="destroy"
          >
            {{ $t('yes') }}
          </VBtn>

          <VBtn
            color="grey darken-1"
            text
            @click="closeDestroyDialog"
          >
            {{ $t('no') }}
          </VBtn>
        </VCard>
      </VDialog>
    </VExpansionPanelContent>
  </VExpansionPanel>
</template>

<script>
import ValidationMixin from '../../mixins/ValidationMixin';
import VacancyFaq from '../../orm/models/Vacancy/VacancyFaq';

export default {
  name: 'VacancyFaq',
  mixins: [ValidationMixin],
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
    faq: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      question: this.faq.question,
      answer: this.faq.answer,
      destroyLoading: false,
      destroyDialog: false,
      editLoading: false,
      editDialog: false,
    };
  },
  methods: {
    showEditDialog() {
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
    },
    showDestroyDialog() {
      this.destroyDialog = true;
    },
    closeDestroyDialog() {
      this.destroyDialog = false;
    },
    async edit() {
      this.withValidationHandling(async () => {
        await VacancyFaq.api().update(this.faq.id, {
          question: this.question,
          answer: this.answer,
        });
        this.closeEditDialog();
      }, 'editLoading');
    },
    async destroy() {
      this.withLoading(async () => {
        await VacancyFaq.api().destroy(this.faq.id);
        this.closeDestroyDialog();
      }, 'destroyLoading');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  edit: Edit
  delete: Delete
  question: Question
  answer: Answer
  close: Close
  save: Save
  deleteWarning: Are you sure you want to delete the question?
  yes: Yes
  no: No
</i18n>

<i18n locale="ru" lang="yaml">
  edit: Редактировать
  delete: Удалить
  question: Вопрос
  answer: Ответ
  close: Закрыть
  save: Сохранить
  deleteWarning: Вы уверены, что хотите удалить вопрос?
  yes: Да
  no: Нет
</i18n>
